import capitalize from 'lodash/capitalize';
import React from 'react';
import { formatDate } from "../../../Format";
import {CellTwoLines} from "../../../tables/CellTwoLines";

const EnvironmentCell = ({row, i18n}) => {

  const date = row.environment == 'production' ? (row.prod_sdk?.date || row.sdkProdDate) : (row.test_sdk?.date || row.sdkTestDate)
  return (<CellTwoLines text={capitalize(row.environment)} subtext={formatDate(date)} />)
}

export default EnvironmentCell
